<template>
    <div class="cheque-form">
        <h4 class="uk-margin-large-top">
            Pay by cheque
        </h4>
        <form-wrapper
            class="uk-form-stacked uk-grid-small"
            :validator="$v.buffer"
            uk-grid
        >
            <div class="uk-width-1-2@m">
                <text-field
                    v-model="buffer.bank"
                    placeholder="Bank"
                    label="Bank"
                    :hide-label="true"
                    name="bank"
                    class="uk-margin-bottom"
                    :v="$v.buffer.bank"
                    :show-error-on-blur-only="true"
                    @input="updateInput"
                />
                <div
                    uk-grid
                    class="uk-grid-small"
                >
                    <div class="uk-width-1-2@s">
                        <text-field
                            v-model="buffer.branch"
                            placeholder="Branch"
                            label="Branch"
                            :hide-label="true"
                            name="branch"
                            :v="$v.buffer.branch"
                            :show-error-on-blur-only="true"
                            @input="updateInput"
                        />
                    </div>
                    <div class="uk-width-1-2@s">
                        <text-field
                            v-model="buffer.drawer"
                            placeholder="Drawer"
                            label="Drawer"
                            :hide-label="true"
                            name="drawer"
                            :v="$v.buffer.drawer"
                            :show-error-on-blur-only="true"
                            @input="updateInput"
                        />
                    </div>
                </div>
            </div>
            <!--
            <div class="uk-width-1-2@m">
            </div>
            -->
        </form-wrapper>
    </div>
</template>

<script>

import { required } from "vuelidate/lib/validators";
import { cloneObject } from '@strangeanimals/common-vue-components/src/helpers/helpers';
const TextField = () => import("@strangeanimals/common-vue-components/src/components/fields/TextField");

export default {
    components: { TextField },
    props: {
        mode: {
            type: String,
            default: () => {
                return "create";
            }
        },
        cheque: {
            type: Object,
            default: () => {
                return {
                    drawer: '',
                    bank: '',
                    branch: ''
                };
            }
        },
    },
    data: function () {
        return {
            buffer: cloneObject(this.cheque),
        };
    },
    watch: {
        value: {
            handler() {
                this.buffer = cloneObject(this.cheque)
            },
            deep: true
        }
    },
    mounted: function () {
        this.init();
    },
    updated: function () {
        this.init();
    },
    validations() {
        return {
            buffer: {
                bank: { required },
                branch: { required },
                drawer: { required }
            }
        };
    },
    methods: {
        validateForm() {
            return !this.$v.buffer.$invalid
        },

        updateInput() {
            return this.$emit('change', { cheque: this.buffer, isValid: this.validateForm() });
        },

        init() {
            const self = this;
            this.$nextTick(function () {
                self.updateInput();
            })
        }
    },
}
</script>
